import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Typography,
  Divider,
  Button,
  Box,
} from "@mui/material";
import { LuCheck, LuX } from "@/Components/Icons/Icons"; 
import { RiErrorWarningFill } from "react-icons/ri";

const SuccessDialog = ({
  open,
  onClose,
  title = "",
  subtitle = "",
  icon: IconComponent,
  label = "Success",
  buttonText = "OK",
  status = "success", 
  secondaryButton,
  okButtonAction,
}) => {
  let bgColor, DefaultIcon;

  switch (status) {
    case "error":
      bgColor = "var(--red-900)";
      DefaultIcon = LuX;
      break;
    case "warning":
      bgColor = "#FFD700";
      DefaultIcon = RiErrorWarningFill;
      break;
      case "success":
      bgColor = "var(--green-600)";
      DefaultIcon = LuCheck;
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          py: 1,
        }}
      >
        {label}
        <IconButton
          onClick={onClose}
          sx={{ fontSize: "30px", color: "var(--brand-950)", "&:hover": { backgroundColor: "transparent" } }}
        >
          &times;
        </IconButton>
      </DialogTitle>

      <Divider />

      <DialogContent sx={{ textAlign: "center", py: 3 }}>
        <Box
          sx={{
            width: 75,
            height: 75,
            borderRadius: "50%",
            backgroundColor: bgColor,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mb: 3,
            mx: "auto",
          }}
        >
          {IconComponent ? <IconComponent size={50} color="var(--gray-0)" /> : <DefaultIcon size={50} color="var(--gray-0)" />}
        </Box>

        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5, maxWidth: "100%", mx: "auto", textAlign: "center" }}>
          <Typography variant="bodyBase" sx={{ wordBreak: "break-word", whiteSpace: "normal" }}>
            {title}
          </Typography>
          <Typography variant="bodyBase" sx={{ wordBreak: "break-word", whiteSpace: "normal" }}>
            {subtitle}
          </Typography>
        </Box>
      </DialogContent>

      <Divider />

      <DialogActions sx={{ justifyContent: "center", gap: 2,py:1}}>
        {secondaryButton && (
          <Button variant="outlined" onClick={secondaryButton.onClick} sx={{ width: 120, border: "1px solid" }}>
            {secondaryButton.text}
          </Button>
        )}

        <Button
          variant="contained"
          onClick={okButtonAction || onClose}
          sx={{ width: 120, backgroundColor: "var(--brand-600)", "&:hover": { backgroundColor: "var(--brand-900)" } }}
        >
          {buttonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SuccessDialog;
